import { removeAllShowClass } from './styleUtils';

const modalClose = (ref) => {
  ref?.current?.classList?.remove('show');
  const allFilterClasses = document.querySelectorAll('.btn-filter');
  removeAllShowClass(allFilterClasses);
};
export default modalClose;
